import { render, staticRenderFns } from "./porta.vue?vue&type=template&id=3e10792f&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./porta.vue?vue&type=script&lang=js&"
export * from "./porta.vue?vue&type=script&lang=js&"
import style0 from "./porta.vue?vue&type=style&index=0&id=3e10792f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e10792f",
  null
  
)

export default component.exports